module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"deleteCurrentData":"Bestehende Daten löschen","file":"Datei","import":"Importieren"},"en":{"deleteCurrentData":"Delete current data","file":"File","import":"Import"}}')
  delete Component.options._Ctor
}
